//
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './styles/main.scss';
import icons from './assets/icons';
import './i18n/i18n';
import App from './App';
import * as fromApp from './store/app';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Icons
React.icons = icons;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={fromApp.store}>
      <BrowserRouter>
        <DndProvider backend={HTML5Backend}>
          <App></App>
        </DndProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
